import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/extensions/components/components.module';
import { ApiServicesModule } from 'src/app/extensions/services/api/api-services.module';
import { UsersRoutingModule } from './users-routing.module';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UserListComponent } from './user-list/user-list.component';
import { ListViewComponent } from './user-list/list-view/list-view.component';
import { CardViewComponent } from './user-list/card-view/card-view.component';
import { UserDetailComponent } from './user-detail/user-detail.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule.forChild(),
    UsersRoutingModule,
    ComponentsModule,
    ApiServicesModule,
    DropDownsModule,
    InputsModule,
    NgbModule,
  ],
  declarations: [UserListComponent, ListViewComponent, CardViewComponent, UserDetailComponent],
})
export class UsersModule {}
